import React from 'react'
import mak_krishnagar from "../images/Mountaineers’ Association of Krishnanagar.jpg"
import misaa_berhampore from "../images/misaa re-union Annual get-together.jpg";
import misaa from "../images/misaa re-union Annual re-union 2024.jpg"
import heropremia_krishnagar from "../images/GP PREMIA GRAND OPENING.jpg"
function SliderOurclient() {
  return (
    <div>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src={mak_krishnagar} className="d-block w-100" alt="Mountaineers’ Association of Krishnanagar"/>
    </div>
    <div className="carousel-item">
      <img src={misaa_berhampore} className="d-block w-100" alt="Mary Immaculate School Alumni Association Berhampore, Murshidabad"/>
    </div>
    <div className="carousel-item">
      <img src={misaa} className="d-block w-100" alt="Mary Immaculate School Alumni Association"/>
    </div>
        <div className="carousel-item">
      <img src={heropremia_krishnagar} className="d-block w-100" alt="Hero Premia Showroom at krishnagar"/>
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default SliderOurclient